import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Do not force redirect on all 401s; let components handle.
    }
    return Promise.reject(err);
  }
);

/**
 * Normalise an axios/FastAPI error into a plain user-facing string.
 * FastAPI 422 puts an array of validation dicts in `detail` — passing that
 * directly to a React renderer (toast/JSX) throws "Objects are not valid as a
 * React child". This helper always returns a string.
 */
export function apiErrorMessage(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    if (parts.length) return parts.join(" · ");
  }
  if (detail && typeof detail === "object" && detail.msg) return String(detail.msg);
  if (typeof err?.message === "string" && err.message) return err.message;
  return fallback;
}
